import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import AssetCard from './components/AssetCard';
import { AssetsListContainer } from './styles';
const AssetsList = ({ assets, disposition, style, }) => {
    const hasIcon = useMemo(() => assets.some((asset) => !!(asset === null || asset === void 0 ? void 0 : asset.fields.icon)), [assets]);
    return (_jsx(AssetsListContainer, { "$disposition": disposition, "$hasIcon": hasIcon, style: style, children: assets.map((asset) => (_jsx(AssetCard, Object.assign({}, asset.fields, { tablet: {
                style: {
                    width: !hasIcon ? '100%' : undefined,
                    maxHeight: `min(60vh, 100%)`,
                },
            } }), asset.sys.id))) }));
};
export default AssetsList;
